<div class="constellation-logo">
  <kp-reflect-animation [skipIntro]="true"></kp-reflect-animation>
</div>
<h1>Let's verify your eligibility.</h1>
